import { render, staticRenderFns } from "./consultationDetailDialog.vue?vue&type=template&id=997e064a&scoped=true"
import script from "./consultationDetailDialog.vue?vue&type=script&lang=js"
export * from "./consultationDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./consultationDetailDialog.vue?vue&type=style&index=0&id=997e064a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997e064a",
  null
  
)

export default component.exports